import {useState,  useEffect, useRef} from 'react';
import * as ModalPage from './modals';
import {DecideWindow} from '../../common/modal_common.js';
import {BsPencilSquare, BsTrash, BsPlusSquare, BsChevronExpand} from 'react-icons/bs';
import {getApiSitesCount, delApiSitesSite, getApiSites, getApiSitesSite, getApiSitesKeyword} from '../../common/fetch_api/site'
import {useInterval, strArraySortAsc, cutFloatlength} from '../../common/app_common.js';
import {PageNation} from '../../common/component_common.js';
import Button from 'react-bootstrap/Button';
import {DetailEdgeCanvas} from './offcanvas';

const PAGE_PER = 16;

const Control = ({setUpdate, searchType, setSearchType, searchName, setSearchName}) => {

    const [modalSiteCreate, setModalSiteCreate] = useState(false);
    const closeModalSiteCreate = () => setModalSiteCreate(false);
    const showModalSiteCreate = () => setModalSiteCreate(true);

    const [selectedAll, setSelectedAll] = useState({disabled:true});

    const [searchList, setSearchList] = useState([]);

    const onChangeType = (e) => {
        setSearchType(e.target.value);
        setSelectedAll(e.target.value === 'all'?{disabled:true}:{disabled:false});
    }

    const onChangeName = (e) => {
        setSearchName(e.target.value);
    }

    useEffect( () => {
        if( searchType === 'all' )
        {
            setSearchList([]);
        }
        else
        {
            Promise.resolve( getApiSitesKeyword() )
            .then( data => {
                const arr = [...data[searchType]].sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));

                setSearchName(arr[0]);

                setSearchList(arr.map( (item, idx) => 
                    <option key={idx} value={item}>{item}</option>
                ));
            });
        }

    }, [searchType] );

    return (
        <>
            <div className="d-flex justify-content-between mt-2 me-2">
                <div className="d-flex manager-search-select">
                    <select className="form-select form-select-sm" value={searchType} onChange={onChangeType}>
                        <option value="all">All</option>
                        <option value="callsign">Callsign</option>
                        <option value="market">Market</option>
                    </select>
                    <select className="form-select form-select-sm ms-2" value={searchName} {...selectedAll} onChange={onChangeName}>
                        {searchList}
                    </select>
                </div>
                <Button variant="primary" className="btn btn-sm" onClick={showModalSiteCreate}>Create Site</Button>
            </div>
            <ModalPage.SiteCreateModal show={modalSiteCreate} handleClose={closeModalSiteCreate} update={setUpdate}></ModalPage.SiteCreateModal>
        </>
    );
};

const Contents = ({getUpdate, searchType, searchName, setTabIndex, setAddEdgeInfo}) => {
    const [update, setUpdate] = useState(false);

    const [tableSpinner, setTableSpinner] = useState(false);
    const [sitesList, setSitesList] = useState([]);
    
    const [siteSelCount, setSiteSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const setPageMove = (e) => {
        setCurPageState(e);
        runUpdate();
    }
    const curPageRef = useRef(0);
    const sortInfo = useRef({title:'', order:''});
    
    const [modalSiteEdit, setModalSiteEdit] = useState(false);
    const [modalSiteInfo, setModalSiteInfo] = useState('');
    const closeModalSiteEdit = () => setModalSiteEdit(false);
    const showModalSiteEdit = (info) =>
    {
        setModalSiteInfo(info);
        setModalSiteEdit(true);
    };

    const [edgeType, setEdgeType] = useState('m-agent');
    const [detailEdge, setDetailEdge] = useState(false);
    const showDetailEdge = () => setDetailEdge(true);
    const cloaseDetailEdge = () => setDetailEdge(false);
    const onClickEdge =(info, type) => {
        setModalSiteInfo(info);
        setEdgeType(type);
        showDetailEdge(true);
    };

    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (info) =>
    {
        setModalSiteInfo(info);
        setModalDecide(true);
    };
    
    const runUpdate = () => {
        setUpdate(!update);
    };

    const onClickSiteRemove = () => {
        Promise.resolve( delApiSitesSite(modalSiteInfo.name) )        
        .then( done => {
            runUpdate();
        });
    };

    function MakeSitesHtml(siteInfo)
    {
        return (
            <tr key={siteInfo.name}>
                <td>{siteInfo.name}</td>
                <td>{siteInfo.market}</td>
                <td>{`${cutFloatlength(siteInfo.latitude)}, ${cutFloatlength(siteInfo.longitude)}`}</td>
                <td>{`${siteInfo.frequency}MHz`}</td>
                <td>{`${cutFloatlength(siteInfo.exciterLatitude)}, ${cutFloatlength(siteInfo.exciterLongitude)}`}</td>
                <EdgeStatus siteInfo={siteInfo}></EdgeStatus>
                <td>
                    <Button variant="primary" className="btn btn-icon" data-bs-toggle="tab" data-bs-target="#pendingContent" onClick={()=>{
                        setTabIndex('Pending');
                        setAddEdgeInfo(siteInfo.name);
                    }}><BsPlusSquare/></Button>
                </td>
                <td>
                    <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalSiteEdit(siteInfo)}}><BsPencilSquare/></Button>
                </td>
                <td>
                    <Button variant="danger" className="btn btn-icon" onClick={() => {showModalDecide(siteInfo)}}><BsTrash/></Button>
                </td>
            </tr>
        )
    };

    const getSites = () =>
    {
        if(searchType === 'all' || searchType === 'market')
        {
            Promise.resolve( getApiSitesCount(searchName, '') )
            .then( data => 
            {
                if(data && data.count > 0)
                {
                    setSiteSelCount(data.count);

                    curPageRef.current.value = Math.min(Math.ceil(data.count/PAGE_PER), curPageState);
                    setCurPageState(parseInt(curPageRef.current.value));

                    Promise.resolve( getApiSites(PAGE_PER, curPageRef.current.value, searchName, '', sortInfo.current.title, sortInfo.current.order) )
                    .then( sitesList => 
                    {
                        if(sitesList)
                        {
                            let apiArr = [];
                            for( let site of sitesList )
                            {
                                apiArr.push( getApiSitesSite([site.site]) );
                            }

                            Promise.all(apiArr)
                            .then( dataArr => {
                                setTimeout(() => {setTableSpinner(false);}, 700);
                                setSitesList( dataArr.map( (siteInfo, index) => MakeSitesHtml(siteInfo) ));
                            })
                            .catch( e => {
                                setTimeout(() => {setTableSpinner(false);}, 700);
                            });
                        }
                    });
                }
                else
                {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                    setSitesList([]);
                    curPageRef.current.value = 1;
                    setCurPageState(1);
                    setSiteSelCount(1);
                }
            });
        }
        else if(searchType === 'callsign')
        {
            if(searchName)
            {
                Promise.resolve( getApiSitesSite(searchName) )
                .then( data =>
                {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                    setSitesList(MakeSitesHtml(data));
                    curPageRef.current.value = 1;
                    setCurPageState(1);
                    setSiteSelCount(1);
                })
                .catch( e => {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                });
            }
            else
            {
                setTimeout(() => {setTableSpinner(false);}, 700);
                setSitesList([]);
                curPageRef.current.value = 1;
                setCurPageState(1);
                setSiteSelCount(1);
            }
        }
    };

    const EdgeStatus = ({siteInfo}) => {
        const mAgentArr = siteInfo.edgeList.filter((x) => {return x.type === 'm-agent'});
        const mAgentLen = mAgentArr.length;

        const sAgentArr = siteInfo.edgeList.filter((x) => {return x.type === 's-agent'});
        const sAgentLen = sAgentArr.length;

        const rAgentArr = siteInfo.edgeList.filter((x) => {return x.type === 'r-agent'});
        const rAgentLen = rAgentArr.length;

        const rmArr = siteInfo.edgeList.filter((x) => {return x.type === 'rm'});
        const rmLen = rmArr.length;

        return (
            <td>
                <Button variant='primary' className={`btn btn-icon edge me-2 ${mAgentLen<1?'disabled':''}`} onClick={() => {onClickEdge(siteInfo, 'm-agent')}}>
                    <span className="edge-item">M{mAgentLen>1?<span className="badge bg-danger">{mAgentLen}</span>:<></>}</span>
                </Button>
                <Button variant='primary' className={`btn btn-icon edge me-2 ${sAgentLen<1?'disabled':''}`} onClick={() => {onClickEdge(siteInfo, 's-agent')}}>
                    <span className="edge-item">S{sAgentLen>1?<span className="badge bg-danger">{sAgentLen}</span>:<></>}</span>
                </Button>
                <Button variant='primary' className={`btn btn-icon edge me-2 ${rAgentLen<1?'disabled':''}`} onClick={() => {onClickEdge(siteInfo, 'r-agent')}}>
                    <span className="edge-item">R{rAgentLen>1?<span className="badge bg-danger">{rAgentLen}</span>:<></>}</span>
                </Button>
                <Button variant='primary' className={`btn btn-icon edge me-2 ${rmLen<1?'disabled':''}`} onClick={rmLen>0?() => {onClickEdge(siteInfo, 'rm')}:()=>{return false;}}>
                    <span className="edge-item">T{rmLen>1?<span className="badge bg-danger">{rmLen}</span>:<></>}</span>
                </Button>
            </td>
        );
    }

    const SetDecideBody = () => {
        return (
            <div>
                <p className='text-center'>Are you sure you want to delete this Site?</p>
                <p className='text-center'>The deleted sites' Edges will be moved to Pending.</p>                
                <div className="d-flex">
                    <div className="col-3 label-box">Callsign</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" value={modalSiteInfo.name} readOnly/>
                    </div>
                </div>
            </div>
        )
    }
    
    function onClickDecide(is)
    {
        if(is)
        {
            onClickSiteRemove();
            // console.log('OK');
        }
        else
        {
            // console.log('CANCEL');
        }
    }
    
    function toggleSort(title)
    {
        let curTitle = sortInfo.current.title;
        let curOrder = sortInfo.current.order;

        if( curTitle === title )
        {
            if( curOrder === 'asc' )
            {
                curOrder = 'desc';
            }
            else
            {
                curOrder = 'asc';
            }
        }
        else
        {
            curTitle = title;
            curOrder = 'asc';
        }

        sortInfo.current = {title: curTitle, order: curOrder};

        getSites();
    }

    const initFlag = useRef(true);
    useEffect(() => {
        // console.log(getUpdate, searchType, searchName, setTabIndex, setAddEdgeInfo);
        if( initFlag.current )
        {
            initFlag.current = false;
            return;
        }
        setTableSpinner(true);
        getSites();
    }, [getUpdate, update]);

    return (
        <>
            <div className="section site-area position-relative mt-2">
                {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                <table className="table">
                    <thead>
                        <tr>
                            <th className="sorting" onClick={() => {toggleSort('name');}}>Callsign<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('market');}}>Market<BsChevronExpand /></th>
                            <th>SiteLocation</th>
                            <th>Frequency</th>
                            <th>ExciterLocation</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sitesList}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setPageMove}
                selCount={siteSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            {modalSiteEdit&&<ModalPage.SiteEditModal siteInfo={modalSiteInfo} show={modalSiteEdit} handleClose={closeModalSiteEdit} update={runUpdate}></ModalPage.SiteEditModal>}
            {modalDecide&&<DecideWindow result={onClickDecide} show={modalDecide} handleClose={closeModalDecide} body={<SetDecideBody/>} okButtonTxt={'Remove'}></DecideWindow>}
            {detailEdge&&<DetailEdgeCanvas siteInfo={modalSiteInfo} edgeType={edgeType} show={detailEdge} handleClose={cloaseDetailEdge} updateParents={runUpdate}></DetailEdgeCanvas>}
        </>
    );
};

export const View = ({setTabIndex, setAddEdgeInfo, runUpdateTab}) => {
    
    const [update, setUpdate] = useState(false);

    const [searchType, setSearchType] = useState('all');
    const [searchName, setSearchName] = useState('');

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect( () => {
        if( searchType !== 'all')
        {
            return;
        }

        setSearchName('');

    }, [searchType]);

    useEffect( () => {
        runUpdate();
    }, [searchName, runUpdateTab]);

    // useInterval(() =>
    // {
    //     runUpdate();
    // }, 30000 );

    return (
        <>
            <Control setUpdate={runUpdate} searchType={searchType} setSearchType={setSearchType} searchName={searchName} setSearchName={setSearchName}></Control>
            <Contents getUpdate={update} searchType={searchType} searchName={searchName} setTabIndex={setTabIndex} setAddEdgeInfo={setAddEdgeInfo}></Contents>
        </>
    );
};
